var getParents = function (elem, selector) {
    // Element.matches() polyfill
    if (!Element.prototype.matches) {
        Element.prototype.matches =
            Element.prototype.matchesSelector ||
            Element.prototype.mozMatchesSelector ||
            Element.prototype.msMatchesSelector ||
            Element.prototype.oMatchesSelector ||
            Element.prototype.webkitMatchesSelector ||
            function (s) {
                var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                    i = matches.length;
                while (--i >= 0 && matches.item(i) !== this) {
                }
                return i > -1;
            };
    }

    // Set up a parent array
    var parents = [];

    // Push each parent element to the array
    for (; elem && elem !== document; elem = elem.parentNode) {
        if (selector) {
            if (elem.matches(selector)) {
                parents.push(elem);
            }
            continue;
        }
        parents.push(elem);
    }

    // Return our parent array
    return parents;
};

document.addEventListener('DOMContentLoaded', () => {
    function hide(show_link, hide_link, rows) {
        show_link.classList.remove('hidden');

        hide_link.classList.add('hidden');

        rows.forEach(function (e) {
            getParents(e, 'tr')[0].classList.add('hidden');
        });
    }

    function show(show_link, hide_link, rows) {
        show_link.classList.add('hidden');

        hide_link.classList.remove('hidden');

        rows.forEach(function (e) {
            getParents(e, 'tr')[0].classList.remove('hidden');
        });
    }

    let panels_ids = [];
    let panel;

    document.querySelectorAll('.row-hider').forEach(function (row) {
        panel = getParents(row, 'div.panel')[0];

        if (panel !== undefined && !panels_ids.includes(panel.id)) {
            panels_ids.push(panel.id);
        }
    });

    if (panels_ids !== []) {
        let show_link,
            hide_link,
            rows;

        panels_ids.forEach(function (panel_id) {
            panel = document.querySelector('#' + panel_id);
            show_link = panel.querySelector('.row-hider-action-link.show-link');
            hide_link = panel.querySelector('.row-hider-action-link.hide-link');
            rows = panel.querySelectorAll('.row-hider');

            hide(show_link, hide_link, rows);

            show_link.addEventListener('click', function (e) {
                e.preventDefault();

                panel = getParents(this, 'div.panel')[0];
                show_link = panel.querySelector('.row-hider-action-link.show-link');
                hide_link = panel.querySelector('.row-hider-action-link.hide-link');
                rows = panel.querySelectorAll('.row-hider');

                show(show_link, hide_link, rows);
            });

            hide_link.addEventListener('click', function (e) {
                e.preventDefault();

                panel = getParents(this, 'div.panel')[0];
                show_link = panel.querySelector('.row-hider-action-link.show-link');
                hide_link = panel.querySelector('.row-hider-action-link.hide-link');
                rows = panel.querySelectorAll('.row-hider');

                hide(show_link, hide_link, rows);
            });
        });
    }
});
